document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'function') {
        const swiperContainers = document.querySelectorAll('.swiper-container');

        swiperContainers.forEach(function(container) {
            const swiper = new Swiper(container, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                    nextEl: container.querySelector('.swiper-button-next'), 
                    prevEl: container.querySelector('.swiper-button-prev'), 
                },
                breakpoints: {
                    482: {
                        slidesPerView: 2,
                    },
                    996: {
                        slidesPerView: 3,
                    },
                },
                on: {
                    init: function () {
                        checkNavigation(this);
                    },
                    resize: function () {
                        checkNavigation(this);
                    }
                }
            });

            function checkNavigation(swiper) {
                const visibleSlides = Array.from(swiper.slides).filter(function(slide) {
                    return slide.style.display !== 'none';
                }).length;

                const currentSlidesPerView = getCurrentSlidesPerView(swiper);
                const totalVisibleSlides = Math.ceil(visibleSlides / currentSlidesPerView);
                
                const navigationElements = [swiper.params.navigation.nextEl, swiper.params.navigation.prevEl];

                navigationElements.forEach(function(element) {
                    if (element) {
                        if (totalVisibleSlides <= 1) {
                            element.style.display = 'none';
                        } else {
                            element.style.display = 'flex';
                        }
                    }
                });
            }

            function getCurrentSlidesPerView(swiper) {
                const width = window.innerWidth;
                if (width >= 996) {
                    return 3;
                } else if (width >= 482) {
                    return 2;
                } else {
                    return 1;
                }
            }

            container.swiperInstance = swiper;

            // Filtering
            const productDropdowns = document.querySelectorAll('.custom-slider-product-dropdown');
    
            productDropdowns.forEach(function(dropdown) {
                const sliderWrapper = dropdown.closest('.custom-slider').querySelectorAll('.custom-swiper-slide');
      
                dropdown.addEventListener('change', function() {
                    const selectedProduct = this.value;
      
                    sliderWrapper.forEach(function(slide) {
                        const productData = slide.getAttribute('data-product');
                
                        if (selectedProduct === '' || (productData && productData.includes(selectedProduct))) {
                            slide.style.display = '';
                        } else {
                            slide.style.display = 'none';
                        }
                    });

                    // Update the swiper instance and re-check navigation
                    if (container.swiperInstance) {
                        container.swiperInstance.update();
                        checkNavigation(container.swiperInstance);
                    }
                });
            });
        });
    } else {
        console.error('Swiper not defined');
    }


    // Update dropdowns and trigger filtering based on URL
    const dropdowns = document.querySelectorAll('.custom-slider-product-dropdown');
    const urlParams = new URLSearchParams(window.location.search);
    const selectedOption = urlParams.get('option');
    
    if (selectedOption) {
        dropdowns.forEach((dropdown) => {
            if (dropdown.value !== selectedOption) {
                dropdown.value = selectedOption;
                dropdown.dispatchEvent(new Event('change'));
            }
        });
    }

    dropdowns.forEach((dropdown) => {
        dropdown.addEventListener('change', (event) => updateURL(event.target));
    });
    
    function updateURL(dropdown) {
        const selectedValue = dropdown.value;
    
        const url = new URL(window.location);
        const searchParams = url.searchParams;
    
        if (selectedValue) {
            searchParams.set('option', selectedValue);
        } else {
            searchParams.delete('option');
        }
    
        const newURL = url.pathname + '?' + searchParams.toString() + url.hash;
    
        window.history.pushState({}, '', newURL);
    }
});
